import React from 'react';
import PropTypes from 'prop-types';
import WorkbenchField from './WorkbenchField.js';
import styles from './WorkbenchFieldList.css';

const WorkbenchFieldList = ({
  fields = [],
  isAccountLevel = false,
  campaigns,
  onFieldUpdate,
  onFieldDelete,
  onFieldValueUpdate,
  onFieldValueAdd,
  onFieldValueDelete,
  isFetching,
  onAddField = () => {
    // do something
  },
  showAddFieldButton = true
}) => {

  const listItems = fields.map((field) => (
    <WorkbenchField
      key={field._id}
      onDelete={onFieldDelete}
      onUpdate={onFieldUpdate}
      field={field}
      campaigns={campaigns}
      isAccountLevel={isAccountLevel}
      onFieldValueUpdate={onFieldValueUpdate}
      onFieldValueAdd={onFieldValueAdd}
      onFieldValueDelete={onFieldValueDelete}
      isFetching={isFetching}
      isExpansionPanelOpen={field.isNewField || false}
      showAddFieldValue={false}
      showAddFieldValueButton
    />)
  );

  return (
    <ul className={styles.fieldList}>
      {listItems}
    </ul>
  );
};

WorkbenchFieldList.propTypes = {
  campaigns: PropTypes.array.isRequired,
  fields: PropTypes.array,
  isAccountLevel: PropTypes.bool,
  onAddField: PropTypes.func,
  showAddFieldButton: PropTypes.bool,
  onFieldUpdate: PropTypes.func,
  onFieldDelete: PropTypes.func,
  onFieldValueUpdate: PropTypes.func,
  onFieldValueAdd: PropTypes.func,
  onFieldValueDelete: PropTypes.func,
  isFetching: PropTypes.bool
};

export default WorkbenchFieldList;
